// 오킴스 의료팀 주요 마일스톤
// ------------------------------------------------------------------
// 메인 페이지 ExpertCredibility 타임라인의 단일 소스.
// 클릭 시 MilestoneModal 이 열려 본문/갤러리/외부 링크를 보여준다.
//
// 데이터 출처: docs/연혁/주요 사건 연혁 ...md 의 [주요 마일스톤] 섹션.
// 본문(body)은 md 카피를 기반으로 사실 범위 안에서만 1~2문장 확장.
//
// 이미지는 `src/assets/images/milestones/` 의 ASCII 정규화 사본을 사용.
// 원본(한글 파일명)은 docs/ 안에 그대로 두고 추적용 매핑은 PR 본문 참조.
//
// 스키마 필드:
//   id          — slug 식 식별자
//   year, date  — 정렬 + 표시
//   title       — 카드/모달 제목
//   summary     — 카드 한 줄
//   body        — 모달 본문
//   items[]     — (옵션) 묶음 사건의 세부 항목. summary 와 body 사이에 - 리스트로 노출
//   primaryImg  — 카드 썸네일 + 모달 헤더 이미지
//   gallery[]   — 모달 추가 이미지
//   outboundLinks[] — { label, url } 외부 보도/자료 링크
//   caseSlug    — (옵션) 블로그 CASES 섹션의 글 slug. 채워두면 모달 안에
//                 "사례 보러 가기" CTA 가 /blog/post/${caseSlug} 로 연결됨.
//                 어드민이 /admin/blog 에서 해당 사건 글을 작성한 뒤
//                 같은 slug 를 이 필드에 채워 넣으면 자동 연결.
//   isCase      — (옵션, 기본 true) 법적 사건이면 true / 회사 행사·인사
//                 같은 비-사건성 마일스톤은 false. false 인 항목은 모달에서
//                 '상세 사례는 준비 중입니다' placeholder 를 숨긴다.
// ------------------------------------------------------------------

import officeOpening01 from '../assets/images/milestones/office-opening-01.jpg';
import okimsTeam01 from '../assets/images/milestones/okims-team-01.jpg';
import okimsTeam02 from '../assets/images/milestones/okims-team-02.jpg';
import okimsTeam03 from '../assets/images/milestones/okims-team-03.jpg';
import megagenImplant from '../assets/images/milestones/megagen-implant.webp';
import publicDoctorTraining from '../assets/images/milestones/public-doctor-training.jpg';
import dentalMeoktwi from '../assets/images/milestones/dental-meoktwi.jpg';
import mamotom from '../assets/images/milestones/mamotom.jpg';
import allerganImplant from '../assets/images/milestones/allergan-implant.jpg';
import allerganInbosa02 from '../assets/images/milestones/allergan-inbosa-02.jpg';
import cataractDefense from '../assets/images/milestones/cataract-defense.webp';
import kmdaAppointment from '../assets/images/milestones/kmda-appointment.jpg';
import residents1st02 from '../assets/images/milestones/residents-1st-02.jpg';
import residents1st03 from '../assets/images/milestones/residents-1st-03.jpg';
import endOfLife2020 from '../assets/images/milestones/end-of-life-2020.webp';
import mbnCorrection from '../assets/images/milestones/mbn-correction.webp';
import mbnCorrection02 from '../assets/images/milestones/mbn-correction-02.jpg';
import psychSuicide from '../assets/images/milestones/psych-suicide.jpg';
import dentalGoodwill from '../assets/images/milestones/dental-goodwill.jpg';
import covidVaccine from '../assets/images/milestones/covid-vaccine.jpg';
import mirKotakinabalu01 from '../assets/images/milestones/mir-kotakinabalu-01.jpg';
import mirKotakinabalu02 from '../assets/images/milestones/mir-kotakinabalu-02.jpg';
import emergency202223 from '../assets/images/milestones/emergency-2022-23.jpg';
import residents2nd from '../assets/images/milestones/residents-2nd.webp';
import anesthesiaDeath from '../assets/images/milestones/anesthesia-death.jpg';
import medicalAdBlog from '../assets/images/milestones/medical-ad-blog.jpg';
import medicalAdBlogNews from '../assets/images/milestones/medical-ad-blog-news.webp';
import dentalMedicalEvalNews from '../assets/images/milestones/dental-medical-eval-news.webp';
import dentalMedicalEvalDetail from '../assets/images/milestones/dental-medical-eval-detail.jpg';
import dentalBaldness from '../assets/images/milestones/dental-baldness.jpg';
import choJinseokPartner from '../assets/images/milestones/cho-jinseok-partner.webp';

export const milestones = [
  {
    id: 'office-opening-2016',
    year: 2016,
    date: '2016',
    title: '오킴스 법률사무소 개소',
    summary: '법률사무소 출범으로 의료 전문 법률 서비스의 첫걸음을 내딛다.',
    body: '2016년, 오킴스 법률사무소가 문을 열었다. 의료 현장을 깊이 이해하는 법률 서비스가 필요하다는 문제의식에서 출발한 작은 사무실은, 이후 의료팀 출범과 법무법인 전환으로 이어지는 모든 여정의 시작점이 되었다.',
    isCase: false,
    primaryImg: officeOpening01,
    gallery: [],
    outboundLinks: [],
  },
  {
    id: 'medical-team-launch-2017',
    year: 2017,
    date: '2017',
    title: '의료팀 출범',
    summary: '진료 현장을 아는 변호사로 구성된 의료팀이 본격 가동되다.',
    body: '2017년, 의사 출신 변호사를 중심으로 의료팀이 출범했다. 진료 현장을 아는 사람이 법적 절차까지 책임지는 구조를 목표로, 의학적 쟁점과 법률 쟁점을 동시에 다루는 통합 변론 체계를 갖추기 시작했다.',
    isCase: false,
    primaryImg: okimsTeam02,
    gallery: [okimsTeam01, okimsTeam03],
    outboundLinks: [],
  },
  {
    id: 'megagen-defense-2017',
    year: 2017,
    date: '2017',
    title: '메가젠임플란트 vs 스트라우만 경영권 방어',
    summary: '세계 최대 임플란트 회사에 맞서 국내 의료인 창업 기업의 경영권을 지켜내다.',
    body: '2017년, 의료인이 창업한 국내 임플란트 회사가 세계 최대 임플란트 기업의 경영권 인수 시도에 직면했다. 오킴스는 메가젠임플란트의 법률 대리인으로서 경영권 방어 소송과 자문을 수행했고, 의료인 창업기업의 독립성을 지켜냈다.',
    primaryImg: megagenImplant,
    gallery: [],
    outboundLinks: [],
  },
  {
    id: 'firm-conversion-2018',
    year: 2018,
    date: '2018',
    title: '법무법인 전환',
    summary: '법무법인으로 전환하여 성장의 토대를 마련하다.',
    body: '2018년, 법률사무소에서 법무법인으로 전환했다. 의료팀의 사건 규모가 커지고 의료기관 자문 수요가 늘어남에 따라 보다 견고한 조직 형태가 필요했고, 이후 본격적인 확장의 토대가 되었다.',
    isCase: false,
    primaryImg: okimsTeam03,
    gallery: [okimsTeam01, okimsTeam02],
    outboundLinks: [],
  },
  {
    id: 'public-doctor-training-2019',
    year: 2019,
    date: '2019',
    title: '공중보건의사 훈련기간 미산입 헌법소원',
    summary: '공중보건의사 훈련기간을 복무기간에 산입하지 않는 제도의 위헌성을 다투다.',
    body: '2019년, 공중보건의사의 훈련기간이 복무기간에 산입되지 않는 제도의 위헌성을 다투는 헌법소원을 수행했다. 공중보건의사 후배들과 함께 의료 인력의 권리 구제를 위한 헌법 차원의 문제 제기를 진행했다.',
    primaryImg: publicDoctorTraining,
    gallery: [],
    outboundLinks: [],
  },
  {
    id: 'dental-meoktwi-2019',
    year: 2019,
    date: '2019',
    title: '“먹튀치과” 투○치과 사건',
    summary: '치과 의료계 질서를 어지럽힌 일련의 분쟁을 수행하여 직역의 신뢰를 회복하다.',
    body: '2019년, 일명 “먹튀치과” 사태로 불린 투○치과 사건과 그와 관련된 일련의 분쟁을 수행했다. 치과 의료계의 질서를 바로 세우는 데 기여했으며, 환자와 정상 의료기관 모두를 보호하기 위한 법적 대응 모델을 정립했다.',
    primaryImg: dentalMeoktwi,
    gallery: [],
    outboundLinks: [],
  },
  {
    id: 'mamotom-2019',
    year: 2019,
    date: '2019',
    title: '맘모톰 절제술 사건 (대한외과의사회)',
    summary: '대한외과의사회와 함께 실손보험사 구상금 청구에 맞서 일반외과 직역을 보호.',
    body: '2019년, 맘모톰 절제술을 둘러싸고 실손보험사들이 일제히 의료기관을 상대로 구상금을 청구한 사건에서 대한외과의사회와 함께 변론을 수행했다. 일반외과 직역의 진료권을 방어하고, 의학적 표준 시술을 보험사 잣대로 부정하려는 시도에 제동을 걸었다.',
    primaryImg: mamotom,
    gallery: [],
    outboundLinks: [],
  },
  {
    id: 'allergan-inbosa-2019',
    year: 2019,
    date: '2019',
    title: '앨러간 가슴보형물 + 코오롱인보사 사건',
    summary: '의료인과 환자가 안전한 제품을 사용할 수 있도록 제조사 책임을 묻다.',
    body: '2019년, 앨러간 가슴보형물 사건과 코오롱인보사 무릎관절염 치료제 사건을 함께 수행했다. 의료인과 환자가 안전한 제품을 사용할 수 있도록 제조사·유통사의 책임을 묻는 변론에 참여했고, 의료 제품 안전성에 대한 사회적 관심을 환기시켰다.',
    primaryImg: allerganImplant,
    gallery: [allerganInbosa02],
    outboundLinks: [],
  },
  {
    id: 'cataract-defense-2019',
    year: 2019,
    date: '2019',
    title: '백내장 시술 실손보험 구상금 소송',
    summary: '실손보험사 구상금 청구에서 안과 의료기관의 진료권을 방어하다.',
    body: '2019년, 백내장 시술에 대한 실손보험사들의 구상금 소송에서 의료기관 측을 대리했다. 보험사의 일괄적인 청구 논리에 맞서 시술의 의학적 타당성을 입증하고, 안과 의료기관의 진료권을 지켜냈다.',
    primaryImg: cataractDefense,
    gallery: [],
    outboundLinks: [],
  },
  {
    id: 'kmda-appointment-2020',
    year: 2020,
    date: '2020',
    title: '조진석 변호사 한국의료분쟁조정중재원 비상임감정위원 위촉',
    summary: '의료분쟁 공적 시스템 안에서 의료팀의 전문성을 인정받다.',
    body: '2020년, 조진석 변호사가 한국의료분쟁조정중재원 비상임감정위원으로 위촉되었다. 의료분쟁 공적 조정 시스템 내에서 의료팀의 전문성을 인정받은 사례로, 이후 다수의 감정·자문 위원직 활동으로 이어졌다.',
    isCase: false,
    primaryImg: kmdaAppointment,
    gallery: [],
    outboundLinks: [],
  },
  {
    id: 'residents-1st-2020',
    year: 2020,
    date: '2020',
    title: '1차 전공의 업무복귀명령 사건',
    summary: '보건복지부 업무개시명령에 맞서 전공의의 옆에 서다.',
    body: '2020년, 보건복지부의 1차 전공의 업무복귀명령 사건에서 전공의들의 법률 대리를 맡았다. 행정명령의 법적 한계를 다투며 전공의 직역의 권리를 변호했고, 의료 정책과 헌법적 권리가 충돌하는 현장에서 의료팀의 역할을 확립했다.',
    primaryImg: residents1st02,
    gallery: [residents1st03],
    outboundLinks: [],
  },
  {
    id: 'end-of-life-2020',
    year: 2020,
    date: '2020',
    title: '말기암 환자 연명의료결정법 위반 사건',
    summary: '의료 현장의 의료진을 변호하며 연명의료 제도의 실무적 한계를 짚다.',
    body: '2020년, 말기 암 환자에 대한 연명의료결정법 위반 혐의 사건에서 의료 현장의 의료진을 변호했다. 제도와 현장의 간극을 사실관계와 의학적 맥락으로 설득력 있게 풀어내, 의료진의 진료행위가 부당하게 형사 책임으로 이어지지 않도록 했다.',
    primaryImg: endOfLife2020,
    gallery: [],
    outboundLinks: [],
  },
  {
    id: 'mbn-correction-2021',
    year: 2021,
    date: '2021',
    title: '구강악안면외과 4개 단체 MBN 정정보도',
    summary: '진료영역을 왜곡한 보도에 대해 언중위 정정보도 결정을 이끌어내다.',
    body: '2021년, 구강악안면외과 관련 4개 단체를 대리하여 MBN 보도에 대한 언론중재위원회 정정보도 결정을 이끌어냈다. 진료영역을 왜곡한 보도에 대한 정정을 통해 치과의사의 명예와 직역을 보호한 의미 있는 사건이다.',
    primaryImg: mbnCorrection,
    gallery: [mbnCorrection02],
    outboundLinks: [
      {
        label: '관련 보도 — 언중위, 진료영역 왜곡 MBN에 ‘정정보도’ 주문',
        url: 'https://www.dentalnews.or.kr/news/article.html?no=31782',
      },
    ],
  },
  {
    id: 'psych-suicide-2021',
    year: 2021,
    date: '2021',
    title: '대학병원 정신건강의학과 입원 환자 자살 사건',
    summary: '정신과 진료의 한계와 합리적 주의의무 범위를 변론하다.',
    body: '2021년, 대학병원 정신건강의학과 입원 환자 자살 사건에서 의료진 측을 변호했다. 정신과 진료의 본질적 한계와 합리적 주의의무 범위를 변론하여, 정신건강의학 임상의 특수성이 법적 판단에 반영되도록 했다.',
    primaryImg: psychSuicide,
    gallery: [],
    outboundLinks: [],
  },
  {
    id: 'dental-goodwill-2021',
    year: 2021,
    date: '2021',
    title: '치과의료기관 영업권 산정 사건',
    summary: '대기업 상대 협상에서 치과 영업권 산정의 기념비적 성과를 거두다.',
    body: '2021년, 치과의료기관의 영업권 산정 사건에서 대기업을 상대로 협상을 수행하여 기념비적 성과를 거두었다. 치과의료기관의 영업권에 대한 합리적 산정 기준을 협상 테이블에서 관철시킨 사례다.',
    primaryImg: dentalGoodwill,
    gallery: [],
    outboundLinks: [],
  },
  {
    id: 'covid-vaccine-2022',
    year: 2022,
    date: '2022',
    title: 'COVID-19 백신 접종 후 사망 사건 의료분쟁 조정',
    summary: '팬데믹 한가운데에서 백신 접종 후 사망 사건의 의료분쟁 조정을 수행하다.',
    body: '2022년, 팬데믹의 중심에서 COVID-19 백신 접종 후 사망 사건의 의료분쟁 조정을 수행했다. 국가 단위 예방접종 정책과 개별 의료기관의 책임 범위가 충돌하는 상황에서 의료기관·의료진의 정당한 입장을 대변했다.',
    primaryImg: covidVaccine,
    gallery: [],
    outboundLinks: [],
  },
  {
    id: 'mir-kotakinabalu-2022',
    year: 2022,
    date: '2022',
    title: '미르치과 코타키나발루 치과병원 설립 자문 완료',
    summary: '5년에 걸친 해외진출 자문으로 의료기관의 해외 거점 설립을 지원하다.',
    body: '2022년, 미르치과 코타키나발루 치과병원 설립에 대한 5년에 걸친 해외진출 자문을 완료했다. 의료기관의 해외 거점 설립이라는 장기 프로젝트를 법률·실무 양면에서 끝까지 이끌어, 의료기관 해외진출 자문의 성과를 입증했다.',
    primaryImg: mirKotakinabalu01,
    gallery: [mirKotakinabalu02],
    outboundLinks: [],
  },
  {
    id: 'emergency-2022-23',
    year: 2022,
    date: '2022~2023',
    title: '응급의료 현장 변호',
    summary:
      '응급의학과·소아응급의료진의 진료행위를 변호하며 응급의료 현장의 구조적 한계를 법정에서 가시화.',
    items: [
      '대학교병원 응급실 대동맥 박리 의심 환자 사망 사건',
      '"응급실 뺑뺑이" 응급의료법 위반 및 시정명령 행정소송',
      '응급실 내원 소아 환자 사망 사건',
    ],
    body: '2022~2023년, 응급의료 현장의 현실을 대변하는 일련의 사건을 수행했다. 각 사건에서 응급의학과 의사와 소아응급의료진의 진료행위를 변호하여, 응급의료 현장의 구조적 한계를 법정에서 가시화했다.',
    primaryImg: emergency202223,
    gallery: [],
    outboundLinks: [],
  },
  {
    id: 'cho-jinseok-partner-2023',
    year: 2023,
    date: '2023',
    title: '조진석 파트너 변호사 합류',
    summary: '의료법 전문 조진석 변호사가 파트너로 합류하며 의료팀 역량이 확장되다.',
    body: '2023년, 의사 출신 조진석 변호사가 파트너 변호사로 합류했다. 한국의료분쟁조정중재원 비상임감정위원, 예방접종피해보상 전문위원, 국립정신건강센터 임상시험심사위원 등 의료 행정·임상 전반의 공적 경력을 갖춘 조 변호사의 합류로 오킴스 의료팀의 임상·자문 역량이 한층 두터워졌다.',
    isCase: false,
    primaryImg: choJinseokPartner,
    gallery: [],
    outboundLinks: [],
  },
  {
    id: 'residents-2nd-2024',
    year: 2024,
    date: '2024',
    title: '2차 전공의 업무복귀명령 사건',
    summary: '잘못된 정책에 맞서 다시 한 번 전공의의 옆에 서다.',
    body: '2024년, 보건복지부의 2차 전공의 업무복귀명령 사건에서 다시 한 번 전공의들의 법률 대리를 맡았다. 조진석 변호사는 사직 전공의 류옥하다 씨의 법률대리인으로서 보건복지부 장관 등을 권리행사방해죄·업무방해죄로 고소하는 등, 정부의 의료 정책에 맞서 전공의 직역의 권리를 변호했다.',
    primaryImg: residents2nd,
    gallery: [],
    outboundLinks: [],
  },
  {
    id: 'anesthesia-death-2024',
    year: 2024,
    date: '2024',
    title: '성형외과 전신마취 악성 고열 사망 사건',
    summary: '성형외과 전신 마취 후 악성 고열 사망 사건에서 마취 의료진을 변호하다.',
    body: '2024년, 성형외과 전신 마취 후 악성 고열로 환자가 사망한 사건에서 마취 의료진을 변호했다. 악성 고열이라는 드문 합병증의 임상적 특성과 응급 대응의 한계를 의학적·법적으로 함께 정리하여 의료진의 정당한 진료행위를 방어했다.',
    primaryImg: anesthesiaDeath,
    gallery: [],
    outboundLinks: [],
  },
  {
    id: 'medical-ad-blog-2025',
    year: 2025,
    date: '2025',
    title: '의료 블로그 대란 의료광고법 헌법소원',
    summary: '의료광고 규제의 위헌성을 헌법재판소 무대에서 다투다.',
    body: '2025년, 의료 블로그 대란 사태에서 의료광고법 규제의 위헌성을 다투는 헌법소원을 수행하고 있다. 의료광고에 대한 사전·사후 규제 체계가 표현의 자유와 직업수행의 자유를 과도하게 제한하는지를 헌법재판소 무대에서 본격적으로 다투는 사건이다.',
    primaryImg: medicalAdBlog,
    gallery: [medicalAdBlogNews],
    outboundLinks: [
      {
        label: '관련 보도 — 의료 블로그 대란 헌법소원',
        url: 'https://www.dentalnews1.com/news/articleView.html?idxno=22971',
      },
    ],
  },
  {
    id: 'dental-medical-eval-2025',
    year: 2025,
    date: '2025',
    title: '치과의료감정원',
    summary: '치과 분야 의료감정 인프라 구축에 법률 자문으로 참여하다.',
    body: '2025년, 치과의료감정원 관련 활동에 참여하고 있다. 치과 분야의 객관적이고 독립적인 의료감정 체계를 마련하기 위한 작업에 법률 자문으로 함께하며, 의료감정 인프라의 제도적 정착을 지원한다.',
    primaryImg: dentalMedicalEvalNews,
    gallery: [dentalMedicalEvalDetail],
    outboundLinks: [
      {
        label: '관련 보도 — 치과의료감정원',
        url: 'https://www.dailydental.co.kr/news/article.html?no=134085',
      },
    ],
  },
  {
    id: 'dental-baldness-2025',
    year: 2025,
    date: '2025',
    title: '치과의사 탈모치료제 자가복용 사건',
    summary: '치과의사 직역을 지키기 위한 헌법소원·행정소송 다수에서 승소.',
    body: '2025년, 치과의사 탈모치료제 자가복용 사건에서 치과의사 직역을 지키기 위한 헌법소원과 다수의 행정소송에서 승소했다. 치과의사의 직역과 권리에 대한 행정 규제의 한계를 법정에서 확인한 사례이다.',
    primaryImg: dentalBaldness,
    gallery: [],
    outboundLinks: [],
  },
];
